import React from 'react';
import './custom.css'
const Papers = () => {
    return (
        <div id='white-papers' style={{ background: '#F2F8FF', paddingTop: '150px', paddingBottom: '50px', marginBottom: '0' }}>
            <h1 data-aos="flip-up" className='text-center whiteHeader'>Wh​itepapers</h1>
            <div className='d-flex justify-content-center my-5'>
                <div className='row g-5 mb-5'>
                    <div className='col-md-3 d-flex justify-content-center' >
                        <div className='p-3 whiteDiv'>
                            <p className='whitepaper_para'>Whitepaper</p>
                            <button className='whitepaperBtn'>Download <i className="ms-2 fas fa-cloud-download-alt" style={{ marginTop: '2px' }}></i></button>
                        </div>
                    </div>
                    <div className='col-md-3 d-flex justify-content-center' >
                        <div className='p-3 pagerDiv'>
                            <p className='whitepaper_para'>One-Pager</p>
                            <button className='pager_Btn'>Download <i className="ms-2 fas fa-cloud-download-alt" style={{ marginTop: '2px' }}></i></button>
                        </div>
                    </div>
                    <div className='col-md-3 d-flex justify-content-center' >
                        <div className='p-3 ecoDiv'>
                            <p className='whitepaper_para'>Economics</p>
                            <button className='EcoBtn'>Download <i className="ms-2 fas fa-cloud-download-alt" style={{ marginTop: '2px' }}></i></button>
                        </div>
                    </div>
                    <div className='col-md-3 d-flex justify-content-center' >
                        <div className='p-3 privacyDiv'>
                            <p className='whitepaper_para'>Privacy Policy</p>
                            <button className='privacy_Btn'>Download <i className="ms-2 fas fa-cloud-download-alt" style={{ marginTop: '2px' }}></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Papers;